const areas = [
  {
    uid: 1,
    id: 'manchester',
    name: 'Manchester',
    number: {
      full: '+44 161 850 8147',
      local: '0161 850 8147'
    },
    photo: 'manchester.jpg',
    description: 'We are situated across convenient and accessible locations in Greater Manchester. We Are Located North, South, East and West Manchester, with Surgeries a maximum of 20 minutes away for most emergencies. With quick access from the M56, M60, M61, M62 M66 and M67. Free parking is usually available. The Areas we cover include: Urmston, Trafford, Sale, Carrington, Eccles, Worsley, Pendlebury, Withington, Didsbury, Northenden, Gatley, Style, Cheadle Hulme, Bramhall, Heald Green, Poynton, Stockport, Marple, Bredbury, Denton, Ancoats, Ashton-Under-Lyne, Bolton, Oldham, Blackley, Rochdale, Bury, Heywood, Whitefield, Prestwich, Middleton .'
  },
  {
    uid: 2,
    id: 'liverpool',
    name: 'Liverpool',
    number: {
      full: '+44 151 329 2860',
      local: '0151 329 2860'
    },
    photo: 'liverpool.jpg',
    description: 'We are situated across convenient and accessible locations in Merseyside. We Are Located North, South, East and central Liverpool, with Surgeries a maximum of 20 minutes away for most emergencies. Quick access from the M62, M57, M58, Queens Drive and East Lancs Road. Free parking is usually available. The Areas we cover include: Aigburth, Aintree, Ainsdale, Allerton, Anfield, Belle Vale, Calderstones, Childwall, Clubmoor, Croxteth, Dovedale, Everton, Fairfield, Fazakerley, Gateacre, Grassendale, Halewood, Huyton, Kensington, Kirkdale, Knotty Ash, Lark Lane, Mossley Hill, Norris Green, Old Swan, Picton, Princes Park, Speke, Stoneycroft, Toxteth, Tuebrook, Wavertree, West Derby, Woolton, Yew Tree.'
  },
  {
    uid: 3,
    id: 'leeds',
    name: 'Leeds',
    number: {
      full: '+44 113 859 0750',
      local: '0113 859 0750'
    },
    photo: 'leeds.jpg',
    description: 'We are situated across convenient and accessible locations in Leeds. We Are Located North, South, East and West Leeds, with Surgeries a maximum of 20 minutes away for most emergencies. Quick access from the M62, M621, M1, the Inner and Outer Ring Roads, Otley Road, York Road, Harrogate Road and Wetherby Road. Free parking is usually available. The Areas we cover include: Adel, Alwoodley, Ardsely, Armley, Bamhope, Beeston, Bramley, Burmantofts, Calverley, Carcroft, Cookridge, Farnley, Farsey, Guisley, Meanwood, Headingley, Hyde Park, Chapeltown, Chapel Allerton, Cross Gates, Gartforth, Harehills, Harewook, Holbeck, Horsforth, Hunslet, Killingbeck, Kipax, Kirkstall, Methley, Middleton, Moortown, Morley, Otley, Pudsey, Rawdon, Richmond Hill, Rothwell, Roundhey, Scarcroft, Seacroft, Shadwell, Stanningley, Swillington, Temple Newsam, Warfedale, Wetherby, Weetwood, Whinmoor, Woodhouse, Wortley, Yeadon.'
  }
]

export default areas
